// import React from 'react';
// import { 
//   FileCheck, ShieldAlert, Users, Scale, 
//   CheckCircle, ChevronLeft, Building, FileText, 
//   AlertTriangle, Briefcase 
// } from 'lucide-react'; // run: npm i lucide-react
// import { ServicePageHeader } from '../ServicePageHeader';

// export default function WorkRegulationsServices() {
  
//   // Scope of labor and regulation services
//   const regulationFeatures = [
//     {
//       title: "صياغة اللائحة وتخصيصها",
//       desc: "إعداد وصياغة لوائح تنظيم العمل المخصصة بما يتوافق مع طبيعة نشاط المنشأة (سواء كانت تجارية، صناعية، أو تقنية) لضمان تغطية كافة الثغرات التشغيلية.",
//       icon: <FileText className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "الاعتماد الفوري عبر منصة قوى",
//       desc: "بصفتنا مكتباً معتمداً ومصرحاً له من وزارة الموارد البشرية والتنمية الاجتماعية، نقوم بتقديم اللائحة ومراجعتها واعتمادها إلكترونياً وبشكل فوري عبر منصة (قوى).",
//       icon: <FileCheck className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "تحديث اللوائح وفقاً للأنظمة الحديثة",
//       desc: "مراجعة وتعديل اللوائح القديمة وتطويرها لتتوافق بشكل كامل مع أحدث التعديلات الطارئة على نظام العمل السعودي والقرارات الوزارية الأخيرة.",
//       icon: <Scale className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "صياغة جداول المخالفات والجزاءات",
//       desc: "تصميم ملاحق المخالفات والجزاءات التأديبية والمكافآت بما يتناسب مع بيئة العمل لديك، وبما لا يخالف أحكام المنظم السعودي لحفظ النظام الداخلي للشركة.",
//       icon: <ShieldAlert className="w-6 h-6 text-amber-600" />
//     }
//   ];

//   return (
//     <div className="bg-white text-right font-sans" dir="rtl">
//       <ServicePageHeader 
//         title="خدمات مراجعة واعتماد لوائح تنظيم العمل"
//         description="نقدم حلولاً قانونية شاملة لدعم نمو الشركات الناشئة وريادة الأعمال في السوق السعودي"
//       />  
//       {/* Hero Header Section */}
//       <section className="relative bg-slate-900 text-white py-24 px-4 overflow-hidden">
//         <div className="absolute inset-0 opacity-15 bg-[url('https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&q=80')] bg-cover bg-center"></div>
//         <div className="max-w-6xl mx-auto relative z-10 text-center">
//           <span className="text-amber-500 font-semibold text-sm md:text-base tracking-wide block mb-3">الحماية القانونية لبيئة العمل وصناعة الاستقرار المهني</span>
//           <h1 className="text-3xl md:text-5xl font-bold mb-6 text-slate-100 leading-tight">مراجعة واعتماد لوائح تنظيم العمل</h1>
//           <p className="text-slate-300 max-w-3xl mx-auto text-base md:text-lg leading-relaxed">
//             نحن نضع بين يديك الصلاحية الرقمية المعتمدة لتوثيق واعتماد لائحة تنظيم العمل الخاصة بمنشأتك عبر منصة قوى، ونصيغ الدستور الداخلي الذي يحمي استثماراتك ويمنع الخلافات العمالية.
//           </p>
//         </div>
//       </section>

//       {/* Compliance & Strategic Value */}
//       <section className="max-w-6xl mx-auto py-20 px-4">
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
//           <div>
//             <h2 className="text-2xl md:text-4xl font-bold text-slate-800 mb-6 leading-tight">
//               اللائحة المعتمدة هي خط دفاعك الأول أمام المحاكم العمالية
//             </h2>
//             <p className="text-gray-600 text-lg leading-relaxed mb-4">
//               يلتزم كل صاحب عمل يضم قطاعه 10 عمال فأكثر بإعداد لائحة لتنظيم العمل. إن غياب هذه اللائحة أو عدم اعتمادها رسمياً يعرض المنشأة لغرامات مالية صارمة من قبل مفتشي الوزارة، فضلاً عن حرمان الإدارة من سلطتها التأديبية القانونية عند ارتكاب الموظف لأي مخالفة.
//             </p>
//             <p className="text-gray-600 text-lg leading-relaxed">
//               يتولى فريقنا القانوني دراسة الهيكل الإداري لمنشأتك، وصياغة البنود التي تضمن انضباط العمل، وتحديد ساعات العمل والراحة، ومكافأة نهاية الخدمة، مع ربطها إلكترونياً وبشكل مباشر ببوابة وزارة الموارد البشرية لضمان الامتثال التام والسريع.
//             </p>
//           </div>
          
//           {/* Quick Checklist for HR / Business Owners */}
//           <div className="bg-slate-50 p-8 rounded-2xl border border-slate-100 space-y-6">
//             <h3 className="text-xl font-bold text-slate-800 mb-2 flex items-center gap-2">
//               <Building className="w-5 h-5 text-amber-600" /> فوائد اعتماد اللائحة المخصصة:
//             </h3>
            
//             <div className="flex gap-3 items-start">
//               <CheckCircle className="w-5 h-5 text-amber-600 shrink-0 mt-1" />
//               <p className="text-gray-600 text-sm leading-relaxed">**تجنب الغرامات:** تفادي العقوبات الدورية الصادرة عن وزارة الموارد البشرية والتنمية الاجتماعية.</p>
//             </div>

//             <div className="flex gap-3 items-start">
//               <CheckCircle className="w-5 h-5 text-amber-600 shrink-0 mt-1" />
//               <p className="text-gray-600 text-sm leading-relaxed">**مشروعية القرارات:** إضفاء الحجية النظامية على قرارات الخصم، الإنذار، أو الفصل بموجب المادة (80).</p>
//             </div>

//             <div className="flex gap-3 items-start">
//               <CheckCircle className="w-5 h-5 text-amber-600 shrink-0 mt-1" />
//               <p className="text-gray-600 text-sm leading-relaxed">**تنظيم مرن للأعمال:** إمكانية إضافة بنود سرية المعلومات، وعدم المنافسة بما يحمي أسرار المنشأة.</p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Grid Display: Core Capabilities */}
//       <section className="bg-slate-900 text-white py-20 px-4">
//         <div className="max-w-6xl mx-auto">
//           <div className="text-center mb-16">
//             <h2 className="text-2xl md:text-4xl font-bold mb-3">شريكك المعتمد لصياغة وحوكمة بيئة العمل</h2>
//             <p className="text-slate-400 max-w-xl mx-auto">نصوغ الأطر واللوائح التي تلائم تطلعاتك التشغيلية وتتوافق مع رؤية الامتثال القانوني</p>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//             {regulationFeatures.map((feature, index) => (
//               <div key={index} className="bg-slate-800/60 p-8 rounded-xl border border-slate-700 hover:border-amber-500 transition-all duration-300">
//                 <div className="bg-slate-700/50 p-3 rounded-lg w-fit mb-5">
//                   {feature.icon}
//                 </div>
//                 <h3 className="text-xl font-bold text-slate-100 mb-2">{feature.title}</h3>
//                 <p className="text-slate-400 text-sm leading-relaxed">{feature.desc}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Regulatory Context Warning */}
//       <section className="max-w-4xl mx-auto py-16 px-4">
//         <div className="bg-amber-50 rounded-xl border border-amber-200 p-6 flex gap-4 items-start">
//           <AlertTriangle className="w-6 h-6 text-amber-600 shrink-0 mt-0.5" />
//           <div>
//             <h4 className="font-bold text-slate-800 mb-1">تنبيه هام للمنشآت والشركات المدمجة:</h4>
//             <p className="text-amber-950 text-sm leading-relaxed">
//               إن مجرد استخدام "اللائحة النموذجية العامة" دون تعديل أو تخصيص قد يحرم منشأتك من تطبيق جزاءات خاصة تتطلبها طبيعة عملك التنافسية أو الميدانية. نوصي دوماً باعتماد اللوائح المخصصة لضمان دمج شروط حماية البيانات، والملكية الفكرية، وساعات نوبات العمل المتغيرة بشكل نظامي ومصادق عليه.
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* Lead Generation Action Box */}
//       <section className="max-w-4xl mx-auto pb-20 px-4 text-center">
//         <div className="inline-flex p-3 bg-slate-100 rounded-full text-slate-800 mb-4">
//           <Briefcase className="w-6 h-6" />
//         </div>
//         <h3 className="text-xl font-bold text-slate-800 mb-2">هل منشأتك مستعدة للامتثال واعتماد اللائحة؟</h3>
//         <p className="text-gray-500 text-sm max-w-xl mx-auto mb-6">
//           تواصل معنا اليوم لتحديث أو صياغة لائحة تنظيم العمل الخاصة بشركتك، ورفعها للاعتماد الفوري عبر حساب منشأتك في منصة قوى لتأمين أعمالك القانونية.
//         </p>
//         <button className="bg-amber-600 text-white font-medium text-sm px-6 py-3 rounded-lg hover:bg-amber-700 transition-colors shadow-md inline-flex items-center gap-2">
//           ابدأ إجراءات مراجعة واعتماد لائحتك الآن
//           <ChevronLeft className="w-4 h-4" />
//         </button>
//       </section>

//     </div>
//   );
// }




import React from 'react';
import { 
  FileCheck, ShieldAlert, Users, Scale, 
  CheckCircle, ChevronLeft, Building, FileText, 
  AlertTriangle, Briefcase 
} from 'lucide-react';
import { ServicePageHeader } from '../ServicePageHeader';
import { openWhatsApp } from '../utils';
import { openWhatsApp2 } from '../utils2';

export default function WorkRegulationsServices() {
  
  // Scope of labor and regulation services - Refactored to Navy Light
  const regulationFeatures = [
    {
      title: "صياغة اللائحة وتخصيصها",
      desc: "إعداد وصياغة لوائح تنظيم العمل المخصصة بما يتوافق مع طبيعة نشاط المنشأة (سواء كانت تجارية، صناعية، أو تقنية) لضمان تغطية كافة الثغرات التشغيلية.",
      icon: <FileText className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "الاعتماد الفوري عبر منصة قوى",
      desc: "بصفتنا مكتباً معتمداً ومصرحاً له من وزارة الموارد البشرية والتنمية الاجتماعية، نقوم بتقديم اللائحة ومراجعتها واعتمادها إلكترونياً وبشكل فوري عبر منصة (قوى).",
      icon: <FileCheck className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "تحديث اللوائح وفقاً للأنظمة الحديثة",
      desc: "مراجعة وتعديل اللوائح القديمة وتطويرها لتتوافق بشكل كامل مع أحدث التعديلات الطارئة على نظام العمل السعودي والقرارات الوزارية الأخيرة.",
      icon: <Scale className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "صياغة جداول المخالفات والجزاءات",
      desc: "تصميم ملاحق المخالفات والجزاءات التأديبية والمكافآت بما يتناسب مع بيئة العمل لديك، وبما لا يخالف أحكام المنظم السعودي لحفظ النظام الداخلي للشركة.",
      icon: <ShieldAlert className="w-6 h-6 text-indigo-950" />
    }
  ];

  return (
    <div className="bg-white text-right font-sans min-h-screen" dir="rtl">
      <ServicePageHeader 
        title="خدمات مراجعة واعتماد لوائح تنظيم العمل"
        description="نضع بين يديك الصلاحية الرقمية المعتمدة لتوثيق واعتماد لائحة تنظيم العمل الخاصة بمنشأتك عبر منصة قوى"
      />  
      
      {/* Hero Header Section - Converted to Premium Light Mode */}
      <section className="relative bg-slate-50 border-b border-slate-100 py-24 px-4 overflow-hidden">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&q=80')] bg-cover bg-center"></div>
        {/* White/Slate overlay for premium executive appearance */}
        <div className="absolute inset-0 bg-white/90 backdrop-blur-[1px]"></div>
        
        <div className="max-w-6xl mx-auto relative z-10 text-center">
          <span className="text-blue-700 font-bold text-xs md:text-sm tracking-wide block mb-3 uppercase">الحماية القانونية لبيئة العمل وصناعة الاستقرار المهني</span>
          <h1 className="text-3xl md:text-5xl font-extrabold mb-6 text-indigo-950 leading-tight">مراجعة واعتماد لوائح تنظيم العمل</h1>
          <p className="text-slate-600 max-w-3xl mx-auto text-base md:text-lg leading-relaxed font-light">
            نحن نضع بين يديك الصلاحية الرقمية المعتمدة لتوثيق واعتماد لائحة تنظيم العمل الخاصة بمنشأتك عبر منصة قوى، ونصيغ الدستور الداخلي الذي يحمي استثماراتك ويمنع الخلافات العمالية.
          </p>
        </div>
      </section>

      {/* Compliance & Strategic Value */}
      <section className="max-w-6xl mx-auto py-20 px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-2xl md:text-4xl font-extrabold text-indigo-950 mb-6 leading-tight">
              اللائحة المعتمدة هي خط دفاعك الأول أمام المحاكم العمالية
            </h2>
            <p className="text-slate-600 text-base md:text-lg leading-relaxed mb-4 font-light">
              يلتزم كل صاحب عمل يضم قطاعه 10 عمال فأكثر بإعداد لائحة لتنظيم العمل. إن غياب هذه اللائحة أو عدم اعتمادها رسمياً يعرض المنشأة لغرامات مالية صارمة من قبل مفتشي الوزارة، فضلاً عن حرمان الإدارة من سلطتها التأديبية القانونية عند ارتكاب الموظف لأي مخالفة.
            </p>
            <p className="text-slate-600 text-base md:text-lg leading-relaxed font-light">
              يتولى فريقنا القانوني دراسة الهيكل الإداري لمنشأتك، وصياغة البنود التي تضمن انضباط العمل، وتحديد ساعات العمل والراحة، ومكافأة نهاية الخدمة، مع ربطها إلكترونياً وبشكل مباشر ببوابة وزارة الموارد البشرية لضمان الامتثال التام والسريع.
            </p>
          </div>
          
          {/* Quick Checklist for HR / Business Owners - Converted to Premium Slate Panel */}
          <div className="bg-slate-50 p-8 rounded-2xl border border-slate-200/60 space-y-6 shadow-sm">
            <h3 className="text-xl font-bold text-indigo-950 mb-2 flex items-center gap-2 border-b border-slate-200 pb-3">
              <Building className="w-5 h-5 text-blue-700" /> فوائد اعتماد اللائحة المخصصة:
            </h3>
            
            <div className="flex gap-3 items-start">
              <CheckCircle className="w-5 h-5 text-blue-700 shrink-0 mt-0.5" />
              <p className="text-slate-600 text-sm leading-relaxed font-light">
                <strong className="font-bold text-indigo-950">تجنب الغرامات:</strong> تفادي العقوبات الدورية الصادرة عن وزارة الموارد البشرية والتنمية الاجتماعية.
              </p>
            </div>

            <div className="flex gap-3 items-start">
              <CheckCircle className="w-5 h-5 text-blue-700 shrink-0 mt-0.5" />
              <p className="text-slate-600 text-sm leading-relaxed font-light">
                <strong className="font-bold text-indigo-950">مشروعية القرارات:</strong> إضفاء الحجية النظامية على قرارات الخصم، الإنذار، أو الفصل بموجب المادة (80).
              </p>
            </div>

            <div className="flex gap-3 items-start">
              <CheckCircle className="w-5 h-5 text-blue-700 shrink-0 mt-0.5" />
              <p className="text-slate-600 text-sm leading-relaxed font-light">
                <strong className="font-bold text-indigo-950">تنظيم مرن للأعمال:</strong> إمكانية إضافة بنود سرية المعلومات، وعدم المنافسة بما يحمي أسرار المنشأة.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Grid Display: Core Capabilities - Converted from Dark to Premium Light Grid */}
      <section className="bg-slate-50/50 border-y border-slate-100 py-20 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-2xl md:text-4xl font-extrabold text-indigo-950 mb-3">شريكك المعتمد لصياغة وحوكمة بيئة العمل</h2>
            <p className="text-slate-500 text-sm md:text-base font-light max-w-xl mx-auto">نصوغ الأطر واللوائح التي تلائم تطلعاتك التشغيلية وتتوافق مع رؤية الامتثال القانوني</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {regulationFeatures.map((feature, index) => (
              <div key={index} className="bg-white p-8 rounded-xl border-t-4 border-t-indigo-950 border-x border-b border-slate-100 shadow-sm hover:shadow-md transition-all duration-300">
                <div className="bg-slate-50 p-3 rounded-lg w-fit mb-5">
                  {feature.icon}
                </div>
                <h3 className="text-xl font-bold text-indigo-950 mb-2">{feature.title}</h3>
                <p className="text-slate-600 text-sm leading-relaxed font-light">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

     
      {/* Regulatory Context Warning - Adjusted to Slate Balance Tone */}

      {/* <section className="max-w-4xl mx-auto py-20 px-4">
        <div className="bg-slate-50 rounded-xl border border-slate-200/60 p-6 flex gap-4 items-start shadow-sm">
          <AlertTriangle className="w-6 h-6 text-indigo-950 shrink-0 mt-0.5" />
          <div>
            <h4 className="font-bold text-indigo-950 mb-1">تنبيه هام للمنشآت والشركات المدمجة:</h4>
            <p className="text-slate-600 text-sm leading-relaxed font-light">
              إن مجرد استخدام "اللائحة النموذجية العامة" دون تعديل أو تخصيص قد يحرم منشأتك من تطبيق جزاءات خاصة تتطلبها طبيعة عملك التنافسية أو الميدانية. نوصي دوماً باعتماد اللوائح المخصصة لضمان دمج شروط حماية البيانات، والملكية الفكرية، وساعات نوبات العمل المتغيرة بشكل نظامي ومصادق عليه.
            </p>
          </div>
        </div>
      </section> */}

      {/* Lead Generation Action Box - Refactored Styles */}
      <section className="max-w-4xl mx-auto pb-20 px-4 text-center">
        <div className="inline-flex p-3 bg-slate-50 rounded-full text-indigo-950 border border-slate-100 shadow-sm mb-4">
          <Briefcase className="w-6 h-6 text-blue-700" />
        </div>
        <h3 className="text-2xl font-bold text-indigo-950 mb-2"> هل منشأتك مستعدة للامتثال واعتماد اللائحة   </h3>
        <p className="text-slate-500 text-lg max-w-xl mx-auto mb-6 font-light">
          تواصل معنا اليوم لتحديث أو صياغة لائحة تنظيم العمل الخاصة بشركتك، ورفعها للاعتماد الفوري عبر حساب منشأتك في منصة قوى لتأمين أعمالك القانونية.
        </p>
        <button 
            onClick={() => openWhatsApp2( "  ابدأ إجراءات مراجعة واعتماد لائحتك الآن  ")}
        
        className="bg-indigo-950 text-white font-bold text-sm px-6 py-3 rounded-lg hover:bg-slate-900 transition-all duration-200 shadow-sm inline-flex items-center gap-2">
        
          {/* ابدأ إجراءات مراجعة واعتماد لائحتك الآن */}
        تواصل معنا للبدء في إجراءات مراجعة و إعتماد اللائحة الآن
          <ChevronLeft className="w-4 h-4" />
        </button>
      </section>

    </div>
  );
}